import React, { useState, useEffect } from 'react';

const Typewriter = ({ delay, isCompleted, setIsCompleted, goBotton, message, setDesabledOptions, chats }) => {
  const [currentText, setCurrentText] = useState('');


  useEffect(() => {
    if (!isCompleted && !message.localStorage) {
      let currentIndex = 0;
      const typing = setInterval(() => {
        if (currentIndex < message?.message?.length - 1) {
          setCurrentText(prevText => prevText + message.message[currentIndex]);
          goBotton();
          currentIndex++;
        } else {
          clearInterval(typing);
          setIsCompleted(true);
          setDesabledOptions(false);
          const saveChats = chats.map(chat => ({ ...chat, localStorage: true }));
          localStorage.setItem("chats", JSON.stringify(saveChats));
        }
      }, delay);

      return () => clearInterval(typing);
    }
  }, [message.message, delay, isCompleted]);

  return <>{currentText}</>;
};

export default Typewriter;